export const THEME_TYPES_TO_CLASSNAME_MAPPING = {
  DEFAULT: 'featureSectionOneWrap',
  BG_BLACK__CLR_WHITE__CTABG_WHITE__CTACLR_BLACK: 'bgBlackColorWhiteTheme',
  // Promo-banner text themes don't apply a FeatureSectionOne wrapper class; map to the default to keep this
  // THEME_TYPES-keyed lookup exhaustive (the class is only applied for BG_BLACK__... anyway).
  PROMO_BLACK_TEXT: 'featureSectionOneWrap',
  PROMO_WHITE_TEXT: 'featureSectionOneWrap',
}
